@if (toggleRailSelector && isEuroAccount) {
<div class="pointer-events-none pt-2 mx-1">
  <finxone-select-dropdown
    id="payment-rail"
    [(ngModel)]="defaultPaymentRail"
    [selectedOption]="defaultPaymentRail"
    [options]="visiblePaymentRailList"
    [optionLabelKey]="'value'"
    [optionValueKey]="'value'"
    [appendToBody]="true"
    [label]="inputLabel"
    (selectionChange)="onChangePaymentRail($event)"
  ></finxone-select-dropdown>
</div>
}
